export const INVALID_CONSUMER_SETTINGS_ERROR = 100127;
export const INVALID_QUEUE_SETTINGS_ERROR = 100128;
